import { render, staticRenderFns } from "./LdAppLayoutPresenter.vue?vue&type=template&id=2ab99e35"
import script from "./LdAppLayoutPresenter.vue?vue&type=script&lang=js"
export * from "./LdAppLayoutPresenter.vue?vue&type=script&lang=js"
import style0 from "./LdAppLayoutPresenter.vue?vue&type=style&index=0&id=2ab99e35&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports